import React, { FC } from 'react'

import { Button, Modal } from 'src/chrome'
import { FlexColumn } from 'src/styled'
import CreditCard from '../CreditCard/CreditCard'
import { useAccount } from 'src/hooks'

interface Props {
  onPurchase: () => void
  onClose: () => void
  amount: number
  isPurchasing: boolean
}
const ExpensePurchaseModal: FC<Props> = props => {
  const { onClose, amount, onPurchase, isPurchasing } = props
  const account = useAccount()
  return (
    <Modal
      animationStyle={'fade'}
      onClose={onClose}
      title={'Purchase Expense'}
      bodyStyles={{ maxHeight: 400 }}
      bodyChildren={
        account.stripeSource &&
        account.stripeSource.__typename === 'CreditCard' ? (
          <FlexColumn
            css={{
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <CreditCard
              cardType={account.stripeSource.brand}
              last4={account.stripeSource.last4}
              name={`${account.firstName} ${account.lastName}`}
              exp={`${account.stripeSource.expMonth}/${account.stripeSource.expYear}`}
            />
            <p
              css={{
                fontSize: 20,
                margin: '20px 0',
                width: 300,
                textAlign: 'center',
              }}
            >
              {`I authorize SendOutCards to charge my credit card on file for the
              amount of: $${amount}`}
            </p>
          </FlexColumn>
        ) : null
      }
      footerChildren={
        <div
          css={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Button
            onClick={onPurchase}
            title={isPurchasing ? 'Purchasing...' : 'Confirm Purchase'}
            disabled={isPurchasing}
          />
        </div>
      }
    />
  )
}

export default ExpensePurchaseModal
